import { print } from 'graphql'
import { CustomerAccessToken } from 'shopify-types'

import { storefrontClient } from '..'
import { RefreshCustomerDocument, type RefreshCustomerMutation } from '../__generated/storefront'
import { UnauthorizedError } from '../errors'

export const refreshCustomer =
  () =>
  async (token: string): Promise<CustomerAccessToken> => {
    const response = await storefrontClient.request<RefreshCustomerMutation>(
      print(RefreshCustomerDocument),
      {
        variables: {
          customerAccessToken: token,
        },
      },
    )

    // No `data` = transient request failure (retryable).
    if (!response.data) {
      throw new Error('Failed to refresh customer token (transient)')
    }

    const payload = response.data.customerAccessTokenRenew

    // `data` but no renewed token = token rejected (expired/invalid).
    if (!payload?.customerAccessToken?.accessToken) {
      throw new UnauthorizedError('Customer access token renewal was rejected')
    }

    return payload.customerAccessToken as CustomerAccessToken
  }
